// extracted by mini-css-extract-plugin
export default {"toggleMfa":"styles_toggleMfa__4o9tV","toggleMfaSlider":"styles_toggleMfaSlider__gaLq-","toggleMfaSwitch":"styles_toggleMfaSwitch__KUg+e"};